import GeneratedGroupStore from "./generated/GeneratedGroupStore"

class GroupStore extends GeneratedGroupStore {

}

export const groupStore = new GroupStore()
